import script from "./AddDependent.vue?vue&type=script&setup=true&lang=js"
export * from "./AddDependent.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__